import Vue from "vue";
import store from "@/store";

//import mDialog from "@/modules/dialog";
import mRest from "@/modules/rest";
import mUtils from "@/modules/utils";

import { APP_MODE } from "@/modules/enums";

export default {
  async reloadMenu(payload) {
    if (store.state.Menu.menuDisabled) {
      store.commit("menu", []);
      return true;
    } else {
      let resp = await mRest.getFullMenu(payload.orderType, payload.priceLevel);
      if (resp && resp.result == "ok") {
        store.commit("menu", []);
        if (resp.categories) {
          this.prepareMenu(resp.categories);
          return true;
        }
      } else {
        return false;
      }
    }
  },

  async addItemLike(itemID) {
    let compCode = store.getters.storeCompanyCode;
    let key = compCode + "_" + itemID;
    let record = await Vue.prototype.$idb.item_like.get(key);
    let now = Date.now();
    if (record && record.last_updated && (now - record.last_updated) < 3600000) {
      Vue.prototype.$toast.info("You have already liked this item.", {
        timeout: 2000
      });
      return;
    }
    mRest.addItemLike(itemID).then((resp) => {
      //console.log("addItemLike resp", resp);
      console.log("companyCode", compCode);
      if (resp && resp.result == "ok") {
        Vue.prototype.$idb.item_like.put({ compCode_itemID: key, last_updated: now });
        let item = store.state.Menu.items.find((i) => i.ID == itemID);
        if (item) {
          Vue.set(item, "likeCount", resp.count);
        } else {
          Vue.prototype.$toast.error("item not found", {
            timeout: 2000
          });
        }
      } else {
        Vue.prototype.$toast.error(resp.result, {
          timeout: 2000
        });
      }
    });
  },

  prepareItemOptions(optionGroups) {
    //const hideSoldoutItems = store.getters.storeConfig?.hideSoldoutItem == true;

    let n_optionGroups = [];
    if (optionGroups) {
      optionGroups.forEach((optc) => {
        n_optionGroups.push(optc);
        optc.items.forEach((opti, index) => {
          //if (opti.soldout && hideSoldoutItems) return;

          opti.ohQty = opti.qty;
          opti.qty = 0;

          if (!opti.active) optc.items.splice(index, 1);
          if (opti.descr) {
            if (!opti.descr1) opti.descr1 = opti.descr;
            if (!opti.descr2) opti.descr2 = opti.descr;

            if (opti.groups) {
              if (opti.groups.length > 0) n_optionGroups = n_optionGroups.concat(this.prepareItemOptions(opti.groups));

              delete opti.groups;
            }
          }
        });
      });
    }

    return n_optionGroups;
  },

  prepareMenu(menu) {
    let favCat = { ID: -1, pID: 0, imageUris: [], items: [], favorite: true };

    store.state.sideComboTags = [];

    let n_menu = [];
    let n_items = [];
    let n_redeemMenu = [];
    let n_redeemItems = [];

    const hideSoldoutItems = store.getters.storeConfig?.hideSoldoutItem == true;
    if (menu && Array.isArray(menu)) {
      const rootCatIDs = store.state.Menu.rootCatIDs;
      menu.forEach((cat) => {
        let catInMenu =
          rootCatIDs == null ||
          rootCatIDs.length == 0 ||
          rootCatIDs.some((i) => cat.fullID.split("/").includes(i.toString()));
        let catImageUris = [];
        let catItems = cat.items;
        let n_cat = mUtils.cloneObject(cat);
        n_cat.items = [];

        catItems.forEach((item) => {
          item.ohQty = item.qty;
          item.qty = 0;
          if ((item.soldout == false || !hideSoldoutItems) && (Vue.prototype.$appMode != APP_MODE.KIOSK || item.bItems.length == 0)) {
            n_cat.items.push(item);

            item["catOrderTypes"] = n_cat.orderTypes;
            item["catFullID"] = n_cat.fullID;
            if (item.scalable && item.weight <= 0) {
              item["orderDisabled"] = true;
            }
            item.options = this.prepareItemOptions(item.options);
            n_items.push(item);

            if (item.imageUri != "") {
              catImageUris.push(item.imageUri);
            }

            if (!item.soldout && !item.disabled) {
              if (item.combos) {
                item.combos.forEach((combo) => {
                  if (store.state.sideComboTags.indexOf(combo.tag) < 0) {
                    store.state.sideComboTags.push(combo.tag);
                  }
                });
              }

              if (catInMenu && item.favorite) {
                favCat.items.push(item);
                if (item.imageUri != "") {
                  favCat.imageUris.push(item.imageUri);
                }
              }

              if (store.getters.pointRedeemEnabled && item.redeemPoints && store.state.serverBuildNo >= 130) {
                let rdmItem = mUtils.cloneObject(item);
                rdmItem.redeemItem = true;
                let rdmCat = n_redeemMenu.find((cat) => cat.ID == item.catID);
                if (rdmCat == null) {
                  rdmCat = mUtils.cloneObject(cat);
                  rdmCat.items = [];
                  rdmCat.imageUris = [];

                  if (store.getters.categoryPosition == "center") {
                    let rdmPcatIDs = rdmCat.fullID.split("/");
                    if (rdmPcatIDs.length > 1) {
                      for (let i = 0; i < rdmPcatIDs.length - 1; i++) {
                        let rdmPcatID = rdmPcatIDs[i];
                        let rdmPcat = n_redeemMenu.find((cat) => cat.ID == rdmPcatID);
                        if (rdmPcat == null) {
                          rdmPcat = menu.find((cat) => cat.ID == rdmPcatID);
                          if (rdmPcat) n_redeemMenu.push(rdmPcat);
                        }
                      }
                    }
                  }

                  n_redeemMenu.push(rdmCat);
                }
                rdmCat.items.push(rdmItem);
                if (rdmItem.imageUri != "") rdmCat.imageUris.push(rdmItem.imageUri);

                if (catInMenu && rdmItem.favorite) {
                  let favRdmCat = n_redeemMenu.find((cat) => cat.ID == -1);
                  if (favRdmCat == null) {
                    favRdmCat = { ID: -1, pID: 0, imageUris: [], items: [], favorite: true };
                    n_redeemMenu.unshift(favRdmCat);
                  }
                  favRdmCat.items.push(rdmItem);
                  if (rdmItem.imageUri != "") favRdmCat.imageUris.push(rdmItem.imageUri);
                }

                n_redeemItems.push(rdmItem);
              }
            }
          }
        });

        n_cat.imageUris = catImageUris;

        if (n_cat.items.length > 0 || (n_cat.child_count > 0 && (store.getters.mainMenuEnabled || store.getters.categoryPosition == "center"))) {
          n_menu.push(n_cat);
        }
      });

      if (favCat.items.length > 0) {
        n_menu.unshift(favCat);
      }
    }

    store.commit("menu", n_menu);
    store.commit("items", n_items);
    store.commit("redeemMenu", n_redeemMenu);
    store.commit("redeemItems", n_redeemItems);

    //console.log("prepareMenu/menu:", n_menu);
  },
};
